// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-lineHeightDefault_cls1__29HOg","cls2":"styleHelpers-lineHeightDefault_cls2__3Cnug styleHelpers-lineHeightDefault_cls1__29HOg"};